import { createContext, useContext } from 'react';

export type ViewBranchContextValue = {
  /** 閲覧中の他者ブランチ (`translations/<slug>`)。null = 自分のブランチ (編集可能)。 */
  viewBranch: string | null;
  setViewBranch: (branch: string | null) => void;
  /** 他者ブランチを閲覧中か。true のとき UI は read-only になる。 */
  isReadOnly: boolean;
};

export const ViewBranchContext = createContext<ViewBranchContextValue | null>(null);

export const useViewBranch = (): ViewBranchContextValue => {
  const ctx = useContext(ViewBranchContext);
  if (ctx === null) throw new Error('useViewBranch must be used within ViewBranchProvider');
  return ctx;
};
